"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
require("./App.css");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
require("bootstrap/dist/css/bootstrap.min.css");
const redux_persist_1 = require("redux-persist");
const storage_1 = tslib_1.__importDefault(require("redux-persist/lib/storage"));
const react_2 = require("redux-persist/integration/react");
const react_router_dom_1 = require("react-router-dom");
const reducer_js_1 = tslib_1.__importDefault(require("./reducer.js"));
const DynamicWhitelist_js_1 = require("./utils/DynamicWhitelist.js");
const magma_dashboard_js_1 = tslib_1.__importDefault(require("./app/pages/dashboard/magma-dashboard.js"));
// // // Request interceptor
// axios.interceptors.request.use(function (config) {
//   let accessToken = localStorage.getItem("ACCESS_TOKEN_SENZAGRO");
//   let serverCallUrl = new URL(config.url);
//   if (!serverCallUrl.pathname.includes("/auth") && !serverCallUrl.pathname.includes("/core") && accessToken) {
//     config.headers["Authorization"] = `Bearer ${accessToken}`;
//     config.headers["Cache-Control"] = "no-cache";
//   }
//   return config;
// }, function (error) {
// return Promise.reject(error);
// });
// // Response interceptor
// axios.interceptors.response.use(
//   async (response) => {
//     return response;
//   },
//   async (error) => {  
//     const status = error.response && error.response.status;
//     const serverCallUrl = new URL(error.config.url);
//     if ((status === 401) && !serverCallUrl.pathname.includes('/oauth')) {
//       localStorage.clear();
//       window.location.href = "/login";
//       return Promise.reject(error);
//     }
//     return Promise.reject(error);
//   }
// );
const persistConfig = {
    key: 'root',
    storage: storage_1.default,
    whitelist: []
};
const persistedReducer = redux_persist_1.persistReducer(persistConfig, reducer_js_1.default);
const store = redux_1.createStore(persistedReducer, {
    setting: {
        toggle: 0,
        isChangePasswordVisible: false,
        isLoading: false,
        isLoadingCount: 0,
        confirmationDialog: {},
        timePicker: {},
    },
    mainStep: { no: 1 },
    samplingMethod: { samplingMethod: "oversampling" },
    trainTestRatio: { trainTestRatio: 80 },
    finalData: [],
    saveCSVDataS21: [],
    ProjectInfo: { projectname: "", problemtype: "", version_name: "" },
    ProjectInitiationData: {
        data: {
            projectName: "",
            projectNameError: "",
            projectVersion: "",
            projectVersionError: "",
            problemType: "",
            problemTypeError: "",
            csv: "",
            stackedCSV: {},
            csvError: "",
            csvFileName: "",
            baseURL: "",
            baseURLError: "",
            accessToken: "",
            accessTokenError: "",
            batch: "",
            batchError: "",
            device: "",
            deviceError: "",
            startDate: "",
            startDateError: "",
            sensor: "",
            sensorError: "",
            endDate: "",
            endDateError: "",
            sensorData: [],
        },
    },
    columnSelectionS22: {
        selectedCategoricalColumns: [],
        selectedNumericalColumns: [],
        selectedTargetColumn: [],
        selectedDateTime: [],
        remainingColumns: [],
        lagVariablesColumnList: [],
        selectedDropColumns: [],
        selectedIndexColumns: [],
        warning: "",
    },
    nullValueColumns: { nullValueColumns: [] },
    featureSelections: {
        featureselection_method: "manualselection",
        featurecolumns: [],
        featureSelectionTargetColumns: [],
        featureSelectionDateTimeColumns: [],
        threshold: 0,
        k: 0,
        featureSelectionRemainingColumns: [],
    },
    columnSelectionS32: {
        selectedLabelEncoding: [],
        selectedOnehotEncoding: [],
        selectedMinMaxScaler: [],
        selectedStandardScaler: [],
        remainingColumns: [],
        anomalyFeatureColumnOperation: "",
        anomalyTargetColumnOperation: "",
    },
    handlingMissingValues: {
        selectedCategoricalRemoveColumns: [],
        selectedCategoricalReplaceWithMode: [],
        selectedCategoricalRemoveRows: [],
        categoricalRemainingColumns: [],
        selectedNumericalRemoveColumns: [],
        selectedNumericalReplaceWithZero: [],
        selectedNumericalReplaceWithMean: [],
        selectedNumericalReplaceWithMedian: [],
        selectedNumericalReplaceWithPrevValue: [],
        selectedNumericalReplaceWithMode: [],
        selectedNumericalRemoveRows: [],
        numericalRemainingColumns: [],
        selectedTargetRemoveColumns: [],
        selectedTargetReplaceWithMode: [],
        selectedTargetRemoveRows: [],
        targetRemainingColumns: [],
        selectedDateTimeRemoveColumns: [],
        selectedDateTimeRemoveRows: [],
        dateTimeRemainingColumns: [],
    },
    outlierVisualizations: { outliersData: [] },
    interpolationData: {
        interpolationBase: [],
        interpolationFrequency: 5,
        labelColumn: "",
        removeRows: [],
        remainingRows: [],
    },
    lagVariables: {
        lagVariablesColumn: "",
        no_ofLagVariables: 12,
        retainLabels: [],
    },
    binary_thresholding: {
        categorical: {},
        numerical: {},
    },
    feature_mapping_data: {
        rename_columns: {},
        drop_columns: []
    },
    data_transform_rsa_ms: {
        algorithm: "",
        domain_knowledge_method: "",
        domain_knowledge: {
            root_nodes: [],
            leaf_nodes: [],
            forbids: [],
            requires: []
        },
        selected_yaml_file: null
    },
    model_selection: {
        method: "",
        event_column: ""
    }
});
const { whitelist } = DynamicWhitelist_js_1.DynamicWhitelist();
console.log("dynamicWhitelist is: ", whitelist);
persistConfig.whitelist = whitelist;
const persistor = redux_persist_1.persistStore(store);
function Automl() {
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(react_2.PersistGate, { loading: null, persistor: persistor },
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(react_router_dom_1.Switch, null,
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/:step?", component: magma_dashboard_js_1.default }))))));
}
exports.default = Automl;
//# sourceMappingURL=Automl.js.map